import script from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=63a9a83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9a83e"]])

export default __exports__